import { getRequest } from '../client';

export const fetchUserMe = async () => {
    const data = await getRequest<any>('api/user/me');

    return data;
};
